module.exports = __webpack_public_path__ + "static/media/starBig.a9a26e2f.svg";